import React, { useState, useCallback } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

import SubmitButton from 'Components/Form/SubmitButton'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'

import { STATUS_BLOCKED } from 'shared/constants'
import * as CONST from 'Reducers/Ambassador/const'

import style from './style'
import SymbolsCounter from '../../../../../../../Components/SymbolsCounter'

function RefusedModalBody({ classes, onSubmit, onCancel }) {
  const [blockReasonOption, setBlockReasonOption] = useState('')
  const [blockCustomText, setBlockCustomText] = useState('')
  const [disable, setDisable] = useState(false)

  const handleBlockForm = useCallback(() => {
    const reason =
      blockReasonOption === CONST.BLOCK_AMBASSADOR_REASON_OTHER
        ? blockCustomText
        : blockReasonOption
    onSubmit({
      statusV2: STATUS_BLOCKED,
      blockedReason: reason,
    })
  }, [blockReasonOption, blockCustomText])

  const handleBlockFormSubmit = useCallback(() => {
    setDisable(true)
    handleBlockForm()
  }, [handleBlockForm])

  const hendleInput = useCallback(e => setBlockCustomText(e.target.value), [
    blockCustomText,
  ])

  const symbolLimit = '100'

  const options = CONST.BLOCK_AMBASSADOR_REASON_OPTIONS.map(option => ({
    label: option,
    value: option,
  }))
  const isSubmitBlockedFormDisabled =
    blockReasonOption.length === 0 ||
    (blockReasonOption === CONST.BLOCK_AMBASSADOR_REASON_OTHER &&
      blockCustomText.length === 0)

  return (
    <Box display="flex" flexWrap="wrap" justifyContent="center" mt={3} mb={3}>
      <Box>
        <p>
          The brand ambassador will be able to complete their remaining booked
          missions before being blocked
        </p>
      </Box>
      <Box my={2} display="flex" width="100%" className={classes.input}>
        <SelectDashboard
          label="Reason:"
          input={{
            name: 'unbookMission',
            value: blockReasonOption,
            onChange: setBlockReasonOption,
          }}
          options={options}
        />
      </Box>
      {blockReasonOption === CONST.BLOCK_AMBASSADOR_REASON_OTHER && (
        <Box
          my={2}
          display="flex"
          width="100%"
          className={classes.input}
          flexDirection="column"
          justifyContent="flex-start"
        >
          <Input
            label="Specific reason:"
            input={{
              value: blockCustomText,
              onChange: hendleInput,
            }}
            meta={{}}
            maxLength={symbolLimit}
          />
          <SymbolsCounter
            valueToCounter={blockCustomText}
            symbolLimit={symbolLimit}
          />
        </Box>
      )}
      <Box my={2} display="flex" width="100%" justifyContent="space-between">
        <SubmitButton value="cancel" onClick={onCancel} />
        <SubmitButton
          value="submit"
          disabled={isSubmitBlockedFormDisabled || disable}
          onClick={handleBlockFormSubmit}
        />
      </Box>
    </Box>
  )
}

export default withStyles(style)(RefusedModalBody)
